module.exports = __webpack_public_path__ + "img/holidays.2aeb84fd.webp";